import { get } from './api';

export const helpAPI = {
  getHelp() {
    return get('admin/help');
  },
};
